module.exports = function() {
  return new Worker(__webpack_public_path__ + "a3edcfbf8bd4204705d2.worker.js");
};